'use client'
import { styled } from '../config'

function Svg(props) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2.75A.75.75 0 0 1 9.75 2h4.5a.75.75 0 0 1 0 1.5H14v5.19l5.36 8.04A3.25 3.25 0 0 1 16.65 21.5H7.35a3.25 3.25 0 0 1-2.71-5.06L10 8.4V3.5h-.25A.75.75 0 0 1 9 2.75ZM11.5 3.5v5.19c0 .15-.04.29-.13.42l-2.34 3.51c.78.13 1.59.46 2.41 1.01.79.53 1.43.74 1.96.74.51 0 1-.18 1.46-.43l-2.73-4.1a.75.75 0 0 1-.13-.42V3.5h-.5Z"
        fill="#parent"
      />
    </svg>
  )
}

export const Experiment = styled(Svg, { fill: '#7C3AED' })
